angular.module('ikeweb.spike.step').value('STEPS', function() {
    var STEPS = {
        ALIGN: 'align',
        MEASURE: 'measure',
        REPORT: 'report'
    };

    STEPS.values = Object.keys(STEPS).map(function(key) {
        return STEPS[key];
    });

    return STEPS;
}());



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/step/steps.js
// module id = 595
// module chunks = 0